import{jsx as e}from"react/jsx-runtime";import{Component as t}from"react";import{calculateRem as n,getOS as a,generateUUID as r}from"@vds-core/utilities";import{AccessibilityTokens as i}from"@vds-tokens/accessibility";import{ButtonIcon as o}from"@vds-core/button-icons";import{ColorTokens as s}from"@vds-tokens/color";import{Fonts as l}from"@vds-core/typography";import{FormControlsTokens as d}from"@vds-tokens/form-controls";import{LayoutTokens as c}from"@vds-tokens/layout";import u from"@vds-core/icons/left-caret";import p from"@vds-core/icons/right-caret";import{TypographyTokens as v}from"@vds-tokens/typography";import f from"styled-components";import{Calendar as m}from"./ReactCalendar/Calendar.js";const g="320px",h=f.div.withConfig({displayName:"CalendarWrapper",componentId:"VDS__sc-t1vc5n-0"})`
  position: ${function({datePicker:e}){return e?"absolute":"relative"}};
  ${function({datePicker:e,calendarPosition:t}){return e&&t}};
  @media screen and (max-width: 359px) {
    left: 50%;
    transform: translateX(-50%);
  }
`,b=f.span.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-t1vc5n-1"})`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:focus {
    outline: none;
  }
  height: ${n(44)};
  width: ${n(44)};
`,_=f(m).withConfig({displayName:"StyledCalendar",componentId:"VDS__sc-t1vc5n-2"})`
  &.react-calendar {
    z-index: 5;
    background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
    box-sizing: content-box;
    ${function({hideContainerBorder:e,surface:t}){return!e&&`\n    border: ${n(1)} solid\n      ${"dark"===t?s.elements.primary.ondark.value:s.elements.primary.onlight.value};\n    `}}
    position: relative;
    border-radius: ${d.border.radius.value};
    padding: ${n(c.space["1X"].value,0)};
    width: ${n(326)};
    min-width: ${n(318)};
    font-family: ${l.VerizonNHGeTX};
    button {
      &:active,
      &:hover,
      &:visited {
        outline: none;
      }
    }
  }

  .react-calendar__month-view {
    padding: 0;
  }

  .react-calendar__month-view__weekdays {
    padding-bottom: ${null};
    justify-content: ${null};
    text-align: center;
    justify-content: center;

    .react-calendar__month-view__weekdays__weekday {
      margin: ${n(6,6)};
      color: ${function({surface:e}){return"dark"===e?s.interactive.active.ondark.value:s.interactive.active.onlight.value}};
      box-sizing: content-box;
      font-size: ${n(v.fontsize.body[12].value)};
      font-family: ${l.VerizonNHGeTX};
      font-weight: ${v.fontweight.regular.value};
      line-height: ${n(v.lineheight.body[16].value)};
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${n(c.space["8X"].value)};
      height: ${n(c.space["8X"].value)};
    }

    abbr[title] {
      font-family: ${l.VerizonNHGeTX};
      text-decoration: none;
    }
  }

  .react-calendar__navigation__label {
    border: none;
    color: ${function({surface:e}){return"dark"===e?s.elements.primary.ondark.value:s.elements.primary.onlight.value}};
    font-size: ${n(v.fontsize.body[12].value)};
    font-family: ${l.VerizonNHGeTX};
    font-weight: ${v.fontweight.bold.value};
    line-height: ${n(v.lineheight.body[16].value)};
    padding: 0;
    margin: ${`${n(0)} ${n(c.space["5X"].value)}`};
    cursor: pointer;
    outline: none;
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .react-calendar__viewContainer {
    margin: ${n(0,parseInt(d.space.inset.value,10)-1,parseInt(d.space.inset.value,10)-1,parseInt(d.space.inset.value,10)-1)};
  }

  @media screen and (max-width: ${g}) {
    .react-calendar__viewContainer {
      margin: ${n(0,parseInt(c.space["2X"].value,10)-1,12,parseInt(c.space["2X"].value,10)-1)};
    }
  }

  .react-calendar__navigation {
    background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
    margin: ${n(parseInt(c.space["3X"].value,10)-1,parseInt(d.space.inset.value,10)-1,0,parseInt(d.space.inset.value,10)-1)};
    padding: ${n(14)};
    flex: 1;
    display: flex;
    -webkit-tap-highlight-color: transparent;
  }

  @media screen and (max-width: ${g}) {
    .react-calendar__navigation {
      margin: ${n(parseInt(c.space["3X"].value,10)-1,parseInt(c.space["2X"].value,10)-1,0,parseInt(c.space["2X"].value,10)-1)};
    }
  }

  button::-moz-focus-inner {
    border: 0;
  }

  abbr {
    position: relative;
    z-index: 1;
    text-decoration: none;
  }

  .react-calendar__navigation__next-button {
    right: ${n(parseInt(d.space.inset.value,10)-1)};

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__prev-button {
    left: ${n(parseInt(d.space.inset.value,10)-1)};

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__next-button[disabled] {
    visibility: hidden;
  }

  .react-calendar__navigation__prev-button[disabled] {
    visibility: hidden;
  }

  .react-calendar__navigation__arrow {
    &:focus {
      outline: none;
      &:not(:hover):not(:visited):not(:active) > ${b} {
        &::after {
          background: transparent;
          border: ${n(1)} dashed
            ${function({surface:e}){return"dark"===e?s.elements.primary.ondark.value:s.elements.primary.onlight.value}};
          box-sizing: border-box;
          content: '';
          height: ${n(24)};
          left: 50%;
          position: absolute;
          border-radius: ${n(i.focusring.space.offset.value)};
          top: 50%;
          transform: translate(-50%, -50%);
          width: ${n(24)};
        }
      }
    }

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__next-button,
  .react-calendar__navigation__prev-button {
    align-items: center;
    border: 0;
    background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
    cursor: pointer;
    display: flex;
    height: ${n(44)};
    justify-content: center;
    padding: 0;
    position: absolute;
    top: ${n(14)};
    width: ${n(44)};
    z-index: 1;

    &:focus {
      outline-offset: -${n(c.space["2X"].value)};
    }
  }

  .react-calendar__navigation__next2-button,
  .react-calendar__navigation__prev2-button {
    display: none;
  }

  .react-calendar__year-view__months {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__decade-view__years {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__decade-view__years {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__century-view__decades {
    display: flex;
    flex-wrap: wrap;
  }

  /* Day tiles */
  .react-calendar__month-view__days {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__tile {
    background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
    border: none;
    box-sizing: content-box;
    color: ${function({disabled:e,surface:t}){return e&&"dark"!==t?s.interactive.disabled.onlight.value:e&&"dark"===t?s.interactive.disabled.ondark.value:"dark"===t?s.elements.primary.ondark.value:s.elements.primary.onlight.value}};
    flex-basis: auto !important;
    font-size: ${n(v.fontsize.body[12].value)};
    font-family: ${l.VerizonNHGeTX};
    font-weight: ${v.fontweight.regular.value};
    line-height: ${n(v.lineheight.body[16].value)};
    overflow: visible !important;
    padding: 0;
    position: relative;
    pointer-events: auto;

    &.react-calendar__month-view__days__day {
      height: ${n(44)};
      width: ${n(44)};
    }

    &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),
    &.react-calendar__tile--active,
    &.react-calendar__tile--hover,
    &.react-calendar__tile--rangeStart,
    &.react-calendar__tile--rangeEnd,
    &.react-calendar__tile--rangeBothEnds {
      color: ${function({surface:e}){return"dark"===e?s.elements.primary.inverse.ondark.value:s.elements.primary.inverse.onlight.value}};
      cursor: pointer;
      &::before {
        background-color: ${function({surface:e}){return"dark"===e?s.background.primary.inverse.dark.value:s.background.primary.inverse.light.value}};
        content: '';
        height: ${function({dateSelectionSize:e}){return n(e)}};
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: ${function({dateSelectionSize:e}){return n(e)}};
        box-sizing: border-box;
        border-radius: ${n(c.space["1X"].value)};
      }
    }

    &:hover:not(.react-calendar__tile--active) {
      &:hover {
        color: ${function({surface:e}){return"dark"===e?s.elements.primary.ondark.value:s.elements.primary.onlight.value}};
        &::before {
          background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
          border-radius: ${n(c.space["1X"].value)};
          box-sizing: border-box;
          border: ${function({surface:e}){return"dark"===e?`${n(1)} solid ${s.elements.primary.ondark.value}`:`${n(1)} solid ${s.elements.primary.onlight.value}`}};
        }
      }
    }

    &:focus {
      background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
      outline: none;
      + svg {
        outline: none;
      }
      &:not(:hover):not(:visited):not(:active) {
        &::after {
          background: transparent;
          border: ${function({surface:e}){return"dark"===e?`${n(1)} dashed ${s.elements.primary.ondark.value}`:`${n(1)} dashed ${s.elements.primary.onlight.value}`}};
          box-sizing: border-box;
          border-radius: ${n(6)};
          content: '';
          height: ${n(44)};
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: ${n(44)};
        }
      }
    }

    &:disabled {
      color: ${function({surface:e}){return"dark"===e?s.interactive.disabled.ondark.value:s.interactive.disabled.onlight.value}};

      &:hover {
        background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
        color: ${function({surface:e}){return"dark"===e?s.interactive.disabled.ondark.value:s.interactive.disabled.onlight.value}};
        cursor: default;
      }

      &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),
      &.react-calendar__tile--hover,
      &.react-calendar__tile--rangeStart,
      &.react-calendar__tile--rangeEnd,
      &.react-calendar__tile--rangeBothEnds {
        color: ${function({surface:e}){return"dark"===e?s.interactive.disabled.ondark.value:s.interactive.disabled.onlight.value}};
        &::before {
          background-color: transparent;
          border: none;
        }
      }
    }
    &.react-calendar__tile--now:not([disabled]) {
      font-weight: ${function({hideCurrentDateIndicator:e}){return e?v.fontweight.regular.value:v.fontweight.bold.value}};
      &:hover:not(.react-calendar__tile--active):not([disabled]) {
        &:hover {
          font-weight: ${function({hideCurrentDateIndicator:e}){return e?v.fontweight.regular.value:v.fontweight.bold.value}};
        }
      }
      &.react-calendar__tile--active:not([disabled]) {
        font-weight: ${function({hideCurrentDateIndicator:e}){return e?v.fontweight.regular.value:v.fontweight.bold.value}};
      }
    }
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${s.interactive.disabled.onlight.value};
    font-weight: ${v.fontweight.regular.value};
    opacity: 0;
    pointer-events: none;
  }

  @media screen and (max-width: 359px) {
    &.react-calendar {
      padding: ${n(c.space["1X"].value,0)};
      width: ${n(318)};
      min-width: ${n(318)};
    }
  }
  .react-calendar__navigation button[disabled] {
    background-color: ${function({surface:e,$transparentBackground:t}){return t?"transparent":"dark"===e?s.elements.primary.onlight.value:s.elements.primary.ondark.value}};
  }
`;class y extends t{constructor(t){var n;super(t),n=this,this.calendarPos=function(){if(void 0!==typeof document&&n.props.inputId){const e=document.getElementById(`${n.props.inputId}-label`),t=e?e.clientHeight:0,a=document.getElementById(n.props.inputId),r=a&&a.getBoundingClientRect(),i=(r?window.innerHeight-r.bottom:0)>53?`top: ${t+52}px;`:`bottom: calc(100% - ${t}px);`;n.setState({calendarPosition:i})}},this._setAttributes=function(){n.allButtons="undefined"!=typeof document?document.getElementsByClassName("react-calendar__tile"):null,n.selectedButton="undefined"!=typeof document?document.getElementsByClassName("react-calendar__tile--active"):null,[].slice.call(n.allButtons).forEach((function(e){var t;const r=e.querySelectorAll("abbr")[0];let i=r.getAttribute("aria-label");e===(null===(t=n.selectedButton)||void 0===t?void 0:t[0])?("android"===a()&&r.setAttribute("aria-live","assertive"),(null==i?void 0:i.includes("selected"))||r.setAttribute("aria-label",`${i} selected`)):(i=null==i?void 0:i.split(" selected")[0],"android"===a()&&r.removeAttribute("aria-live"),i&&r.setAttribute("aria-label",i))}))},this._findNextDay=function(e,t){const{parse:a}=Date;let r=!1;if(t&&t.forEach((function(t){("string"==typeof t?new Date(a(t)):t).getTime()===e.getTime()&&(r=!0)})),r){const a=new Date(e);return a.setDate(e.getDate()+1),n._findNextDay(a,t)}return e},this._getDate=function(){const{selectedDate:e,inactiveDates:t,activeDates:a}=n.props,r=e,i=t,o=a,{parse:s}=Date;if(null===r)return null;let l,d,c;return l=void 0===r||""===r?new Date:r,l="string"==typeof l?new Date(s(l)):l,i?(d=i||"",l.setHours(0,0,0,0),n._findNextDay(l,d)):o?(c=o||"",l.setHours(0,0,0,0),function(e,t){const{parse:n}=Date;let a=!1,r=new Date(864e13);return null==t||t.forEach((function(t){const i="string"==typeof t?new Date(n(t)):t;i.getTime()===e.getTime()?(r=i,a=!0):i.getTime()<r.getTime()&&!a&&(r=i)})),r}(l,c)):l},this._onChange=function(e){n.setState({selectedDate:e}),void 0!==n.props.onChange&&n.props.onChange(e)},this._toggleDates=function(){let e,t;const{inactiveDates:a,activeDates:r}=n.props;if(a&&a.length)e=a,t=!0;else{if(!r||!r.length)return null;e=r,t=!1}return function({date:n}){return e.filter((function(e){const t=new Date(e);return t.setHours(0,0,0,0),n.getTime()===t.getTime()})).length?t:!t}},this._renderNextLabel=function(t,a){const{surface:r}=n.props,i=document.getElementById(`${n.nextButtonId}-nextNavWrapper`);if(i&&(i.removeAttribute("tabindex"),n.isAndroid&&i.removeAttribute("aria-label")),a&&void 0!==n.nextButtonId){const e=document.getElementById(n.nextButtonId);e&&!e.disabled&&(i.setAttribute("tabindex","-1"),n.isAndroid&&i.setAttribute("aria-label","view next month button disabled"),i.focus())}return e(b,{id:`${n.nextButtonId}-nextNavWrapper`,children:e(o,{id:n.nextButtonId,kind:"ghost",size:"40px",surface:r,onClick:t,iconOffset:{x:2,y:0},ariaLabel:a&&n.isAndroid?"":"view next month",ariaHidden:!!a&&n.isAndroid,disabled:a&&a,renderIcon:function(t){return e(p,Object.assign({},t,{size:16}))}})})},this._renderPrevLabel=function(t,a){const{surface:r}=n.props,i=document.getElementById(`${n.previousButtonId}-prevNavWrapper`);if(i&&(i.removeAttribute("tabindex"),n.isAndroid&&i.removeAttribute("aria-label")),a&&void 0!==n.previousButtonId){const e=document.getElementById(n.previousButtonId);i&&e&&!e.disabled&&(n.isAndroid&&i.setAttribute("aria-label","view previous month button disabled"),i.setAttribute("tabindex","-1"),i.focus())}return e(b,{id:`${n.previousButtonId}-prevNavWrapper`,children:e(o,{id:n.previousButtonId,kind:"ghost",size:"40px",surface:r,onClick:t,iconOffset:{x:-2,y:0},ariaLabel:a&&n.isAndroid?"":"view previous month",ariaHidden:!!a&&n.isAndroid,disabled:a&&a,renderIcon:function(t){return e(u,Object.assign({},t,{size:16}))}})})},this.state={selectedDate:this._getDate(),calendarPosition:void 0}}componentDidMount(){this._setAttributes(),this.calendarPos(),this.previousButtonId=r(),this.nextButtonId=r(),this.isAndroid="android"===a()}componentDidUpdate(e){var t;e&&e.selectedDate!==this.props.selectedDate&&this.setState({selectedDate:null!==(t=this.props.selectedDate)&&void 0!==t?t:""}),e&&e.isOpen!==this.props.isOpen&&this.calendarPos(),this._setAttributes(),"undefined"!=typeof window&&window.addEventListener("resize",this.calendarPos)}componentWillUnmount(){"undefined"!=typeof window&&window.removeEventListener("resize",this.calendarPos)}render(){var t=this;const{disabled:n,minDate:a,maxDate:r,surface:i,hideCurrentDateIndicator:o,dateSelectionSize:s,indicators:l,transparentBackground:d}=this.props,{selectedDate:c}=this.state,u={weekday:"long",year:"numeric",month:"long",day:"numeric"};return null==l||l.splice(3),this.props.isOpen?e(h,{datePicker:this.props.datePicker,calendarPosition:this.state.calendarPosition,children:e(_,Object.assign({},this.props,{$transparentBackground:d,minDetail:"month",maxDetail:"month",disabled:n,showNeighboringMonth:!1,isOpen:this.props.isOpen,calendarType:"US",formatLongDate:function(e,t){return t.toLocaleDateString("en",u)},formatShortWeekday:function(e,t){return["S","M","T","W","T","F","S"][t.getDay()]},tabIndex:0,nextAriaLabel:"view next month",onNextMouseEnter:this._toggleNextHoverOn,onNextMouseLeave:this._toggleNextHoverOff,nextLabel:this._renderNextLabel,onChange:this._onChange,prevAriaLabel:"view previous month",onPrevMouseEnter:this._togglePrevHoverOn,onPrevMouseLeave:this._togglePrevHoverOff,prevLabel:this._renderPrevLabel,value:c,minDate:a,maxDate:r,tileDisabled:this._toggleDates(),onClickDay:function(e,n){return function(e,t,n){n&&0!==t.screenX&&0!==t.screenY&&t.currentTarget.blur()}(0,n,t.props.datePicker)},surface:i,hideCurrentDateIndicator:o,dateSelectionSize:s,indicators:l}))}):null}}y.defaultProps={selectedDate:void 0,minDate:new Date,hideCurrentDateIndicator:!1,dateSelectionSize:40,transparentBackground:!1,surface:"light",hideContainerBorder:!1,isOpen:!0};export{y as default};
